import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=ea288716&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=ea288716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea288716",
  null
  
)

export default component.exports